<template>
<div class="genericTable">

  <div class="actions">

    <h2>{{section.name}}</h2>

    <b-button @click="addNew(section)"
              variant="primary">New {{section.single}}</b-button>

  </div>

  <b-card class="content"
          no-body>
    <b-table :items="items"
             :fields="section.fields"
             class="availableProjects"
             @row-clicked="rowClicked"
             show-empty
             hover>

      <template v-slot:cell(project-client-name)="data">
        <template v-if="data.item.client">{{ data.item.client.name}}</template>
        <template v-else> — </template>
      </template>

      <template v-slot:cell(provider-verified)="data">
        <VerificationBadge :status="data.item.verified" />
      </template>

      <template v-slot:cell(skill-category)="data">
        <template v-if="data.item.category">{{ data.item.category.text}}</template>
        <template v-else>{{data.item.text}}</template>
      </template>

    </b-table>
  </b-card>


</div>
</template>

<script>
import VerificationBadge from '@/components/VerificationBadge.vue'
export default {
  name: 'Table',
  components: {
    VerificationBadge
  },
  props: {
    section: Object,
    items: Array,
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    rowClicked( record, index ) {
      this.$emit( 'row-clicked', record, index )
    },
    addNew( section ) {
      this.$emit( 'add-new', section )
    }
  }
}
</script>


<style scoped lang="scss">
@import "@/styles/global.scss";

.genericTable {
    display: grid;
    grid-template-rows: 5rem auto 1fr;

    .actions {
        display: grid;
        grid-template-columns: 1fr auto;
        align-items: center;
    }

}
</style>
